/* LE NIVEAU DE PLANIFICATION EFFECTIF (2026-09-29) : choisi une fois pour le
   client dans Paramètres › Planification (`planning_level`), Pro demandant Finance.
   Même règle qu'au serveur (`cash_sources_service.plan_mode`) ; tous les
   écrans qui le lisent passent par ici. */
export const planningLevel = (tenant) => (
  tenant?.planning_level === 'pro' && (tenant?.enabled_modules || []).includes('financials') ? 'pro' : 'manual'
);
